import { render } from "./systemMessage.vue?vue&type=template&id=2f80003c&scoped=true"
import script from "./systemMessage.vue?vue&type=script&lang=js"
export * from "./systemMessage.vue?vue&type=script&lang=js"

import "./systemMessage.vue?vue&type=style&index=0&id=2f80003c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f80003c"]])

export default __exports__